module.exports = __webpack_public_path__ + "img/Group1000004938.59735e2d.png";